module.exports = __webpack_public_path__ + "img/icon.7ddeb7d7.png";